<template>
  <div class="option-summary-box">
    <router-link :to="'/' + token + '/gallery'" class="option-card">
      <img src="@/assets/img/option-cards/gallery-orange.svg" alt="" />
    </router-link>

    <router-link disabled :to="'/' + token + '/map'" class="option-card">
      <img src="@/assets/img/option-cards/map-pin-orange.svg" alt="" />
    </router-link>

    <a
      :href="'http://polotik.com/sellers/' + themeInfo?.info?.business.id"
      class="option-card"
    >
      <img src="@/assets/img/option-cards/polotik-orange.svg" alt="" />
    </a>
    <router-link :to="'/' + token + '/weblog'" class="option-card">
      <img src="@/assets/img/option-cards/weblog-orange.svg" alt="" />
    </router-link>

    <div class="qrcode-div">
      <div class="qrcode" @click="qrcodeZoomActive = !qrcodeZoomActive">
        <img :src="'https://witrino.com/qr-code/' + token + '.png'" alt="" />
      </div>
    </div>
  </div>
  <transition name="zoom">
    <div
      v-if="qrcodeZoomActive"
      class="qrcode-zoom"
      @click="qrcodeZoomActive = !qrcodeZoomActive"
    >
      <img :src="'https://witrino.com/qr-code/' + token + '.png'" alt="" />
      <p>{{ token }}</p>
      <p>تصویر فوق را اسکن کنید</p>
    </div>
  </transition>
</template>

<script>
import { sellerData } from "@/repo/sellerData.js";
import { mapGetters } from "vuex";
export default {
  name: "OptionSummary",
  mixins: [sellerData],
  data() {
    return {
      qrcodeZoomActive: false,
      token: null,
    };
  },
  async mounted() {
    await this.$nextTick();
    this.token =
      this.themeInfo?.info?.business.token || this.$route.params.token;
  },
  computed: {
    ...mapGetters({
      themeInfo: "theme/themeInfo",
    }),
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/OptionSummary/OptionSummary.css);
</style>